var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyDnaClocheIcon = function SvgWhyDnaClocheIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 3.59998L26 11.1614",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4697 45.457L2.53059 45.457",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01894 31.3779C1.79698 33.5026 3.55632 35.2427 5.6926 35.2427H46.3074C48.4437 35.2427 50.203 33.5026 49.9811 31.3779C48.6179 18.3287 40.1329 11.0672 26 11.0672C11.8671 11.0672 3.3821 18.3287 2.01894 31.3779Z",
    fill: "#FEECAB",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhyDnaClocheIcon;